/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Message_ReportInputs */

const en_us2_clubs_message_report = /** @type {(inputs: Clubs_Message_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report`)
};

const pt_br2_clubs_message_report = /** @type {(inputs: Clubs_Message_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denunciar`)
};

const es_419_clubs_message_report = /** @type {(inputs: Clubs_Message_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denunciar`)
};

const pt_pt2_clubs_message_report = /** @type {(inputs: Clubs_Message_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denunciar`)
};

const fr_fr2_clubs_message_report = /** @type {(inputs: Clubs_Message_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signaler`)
};

const de_de2_clubs_message_report = /** @type {(inputs: Clubs_Message_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melden`)
};

const it_it2_clubs_message_report = /** @type {(inputs: Clubs_Message_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segnala`)
};

/**
* | output |
* | --- |
* | "Report" |
*
* @param {Clubs_Message_ReportInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_message_report = /** @type {((inputs?: Clubs_Message_ReportInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Message_ReportInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_message_report(inputs)
	if (locale === "es-419") return es_419_clubs_message_report(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_message_report(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_message_report(inputs)
	if (locale === "de-DE") return de_de2_clubs_message_report(inputs)
	if (locale === "it-IT") return it_it2_clubs_message_report(inputs)
	return en_us2_clubs_message_report(inputs)
});
export { clubs_message_report as "clubs.message_report" }